export default __webpack_public_path__ + "static/media/5_1_2.5c6d81c9.png";